import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import DatetimePicker from 'vuetify-datetime-picker'
import vuetifyToast from 'vuetify-toast'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import * as dayjs from "dayjs";
import 'dayjs/locale/nb'

dayjs.locale('nb');

import 'vuetify-datetime-picker/src/stylus/main.styl'

Vue.config.productionTip = false;

Vue.use(DatetimePicker);

Vue.prototype.$snackbar = vuetifyToast;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
